import moment from 'moment';
import { DATE_SETTINGS } from 'config';

export default (dateFrom, dateTo) => (
  `${moment(dateFrom).format(DATE_SETTINGS.FORMAT.MONTH_DAY_YEAR)} - ${moment(dateTo).format(DATE_SETTINGS.FORMAT.MONTH_DAY_YEAR)}`
);
